import { render, staticRenderFns } from "./marketplaceAdminDetail.vue?vue&type=template&id=4fc98cac&scoped=true&"
import script from "./marketplaceAdminDetail.vue?vue&type=script&lang=js&"
export * from "./marketplaceAdminDetail.vue?vue&type=script&lang=js&"
import style0 from "./marketplaceAdminDetail.vue?vue&type=style&index=0&id=4fc98cac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc98cac",
  null
  
)

export default component.exports